import {IStorage} from './types';

export const Storage: IStorage = {
  get: key => localStorage.getItem(key) || undefined,
  set: (key, value) => localStorage.setItem(key, value),
  remove: key => localStorage.removeItem(key),
};
